import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AuthService } from '../../services/index';
import * as fromCommonStore from '../../store';
import * as commonActions from '../../store/actions/common.actions';


@Component({
    moduleId: module.id,
    templateUrl: 'login.component.html'
})

export class LoginComponent implements OnInit {
    user: any = {};
    loading = false;
    returnUrl: string;
    isLoadMask: Promise<any>;
    errorMsg: string;
    constructor(
        private store: Store<fromCommonStore.State>,
        private route: ActivatedRoute,
        private router: Router,
        private authService: AuthService) { }

    ngOnInit() {
        
    }

    onEnterKeyPressed(nextEl: string): void {
        $('#' + nextEl).focus();
    }

    login() {
        this.loading = true;
        let that = this;
        this.isLoadMask = this.authService
            .login(this.user)
            .then((res:any) =>{
                if(res.success){
                    this.store.dispatch(new commonActions.IsAuth(true));
                    //localStorage.setItem('currentUser', 'Abdul');
                    this.router.navigate([''], {skipLocationChange: true});
                }else{
                    this.errorMsg = res.msg;
                }
            })
            .catch((error: any) => {
                console.log(error);
            });
    }
}


// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/login/login.component.ts